import { Component, inject, input, output } from '@angular/core';
import { RiskRegistry } from '@webapp/risk-core';

import { QuoterCoverageCardComponent } from '../quoter-coverage-card/quoter-coverage-card.component';
import { QuoterSidebarCoverageComponent } from '../quoter-sidebar-coverage/quoter-sidebar-coverage.component';
import { ICoverage } from '@webapp/payments';
import { DisclaimerComponent } from '@webapp/core/ui/components/disclaimer/disclaimer.component';

@Component({
  selector: 'app-quoter-coverages-result',
  imports: [QuoterCoverageCardComponent, DisclaimerComponent, QuoterSidebarCoverageComponent],
  templateUrl: './quoter-coverages-result.html',
  styleUrl: './quoter-coverages-result.scss',
})
export class QuoterCoveragesResultComponent {
  coverages = input<ICoverage[]>();
  risk = input('');
  additionalCoverage = input<ICoverage>();
  currency = input<string>();

  private readonly riskRegistry = inject(RiskRegistry);

  coverageSelected = output<ICoverage>();

  /** An optional garage is offered as an add-on, not as a plan card. */
  shouldDisplayCoverage(coverage: ICoverage): boolean {
    const offersOptionalGarage = this.riskRegistry.find(this.risk())?.capabilities.garage === 'optional';
    return !(offersOptionalGarage && coverage.type === 'garage');
  }

  setCoverage(coverage: ICoverage) {
    this.coverageSelected.emit(coverage);
  }

}
